import { getOgAdContext } from './environment-utils';
import { sendCustomTrack } from './TrackAnalyticsHelper';
import { isValidUrl } from './url-utils';

export function encapsulateClickUrlIfNeeded(url: string): string {
  const ogAdContext = getOgAdContext();
  if (ogAdContext.ad_manager_click_url) {
    if (isValidUrl(ogAdContext.ad_manager_click_url)) {
      return ogAdContext.ad_manager_click_url + encodeURIComponent(url);
    } else {
      sendCustomTrack('ad_manager_click_url_invalid', undefined, {
        ad_manager_click_url: ogAdContext.ad_manager_click_url
      });
    }
  }

  return url;
}
